export default {"src":"https://static.spiritory.com/_next/static/media/BayStartUP.56c8acf5.svg","height":85,"width":257,"blurWidth":0,"blurHeight":0};